import styled from "@emotion/styled";

import { ButtonT3, ButtonT4, ButtonT9 } from "Components/Common/Button/index";
import {
  LabelT1,
  LabelT2,
  LabelT4,
  LabelT5,
} from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import { Spacer } from "Components/Common/Spacer/index";
import {
  FlexWrapperT11,
  FlexWrapperT12,
  FlexWrapperT4,
  FlexWrapperT7,
} from "Components/Common/Wrapper/FlexWrapper";
import { Wrapper } from "Components/Common/Wrapper/index";
import { ReactComponent as ArrowOutline } from "Icons/ArrowOutline.svg";
import React, { Fragment } from "react";
const options = [
  { value: "Lucknow", label: "Lucknow" },
  { value: "All", label: "All" },
  { value: "Mundra", label: "Mundra" },
];

const SelectStyles = {
  control: (styles, state) => {
    return {
      ...styles,
      width: "100%",
      // minWidth: "180px",
      // maxWidth: "250px",
    };
  },
  option: (styles, state) => {
    return {
      ...styles,
    };
  },
};

const FilterBox = (props) => {
  const {
    fromList,
    toList,
    commodityCategoryList,
    handleFilterBoxOnChange,
    handleOnClickForFilterBoxSearchButton,
    isMoreFilterOpen,
    handleToggleForMoreFilterBtn,
    freightDays,
    avgFreight,
    handleOnChangeAvgFreight,
    vehicleDetails,
    vehicleType,
    handleOnChangeVehicleType,
    railRakeList,
    railRake,
    handleOnChangeRailRake,
    wagonTypes,
    wagonType,
    handleOnChangeWagonType,
    originYardList,
    destinationYardList,
    originYard,
    destinationYard,
    handleOnChangeOriginYard,
    handleOnChangeDestinationYard,
    handleOnChangeCommodityCategory,
    commodityCategory,
    filterQueryParams
  } = props;
 

  const getWidth = (data={},extraPx = 0) =>{
    let width = '180px'

    if(!!!data){
      return width
    }

    width = ((data.label ||'').length*13) + extraPx

    if(!!width && width > 180){
       return width +'px'
    }


    return '180px'
  }
  return (
    <Fragment>
      <FilterBoxWrapper>
        <FlexWrapperT11>
          <LeftSideWrapper>
            <Wrapper style={{ flex: "1" }}>
              <LabelT1>From</LabelT1>
              <Spacer spacing={"2px"} />
              <SelectT1
                styles={SelectStyles}
                isClearable={true}
                options={fromList}
                onChange={(data) => {
                  handleFilterBoxOnChange(data, "from");
                }}
                value = {filterQueryParams.from}
              />
            </Wrapper>
            <Wrapper style={{ flex: "1" }}>
              <LabelT1>To</LabelT1>
              <Spacer spacing={"2px"} />
              <SelectT1
                styles={SelectStyles}
                isClearable={true}
                options={toList}
                onChange={(data) => {
                  handleFilterBoxOnChange(data, "to");
                }}
                value = {filterQueryParams.to}
              />
            </Wrapper>
            {/* <Wrapper>
              <LabelT1>Commodity Category</LabelT1>
              <Spacer spacing={"2px"} />
              <SelectT1
                isClearable={true}
                options={commodityCategoryList}
                onChange={(data) => {
                  handleFilterBoxOnChange(data, "commodityCategory");
                }}
              />
            </Wrapper> */}
          </LeftSideWrapper>
          <RightSideWrapper>
            <ButtonT4 onClick={handleOnClickForFilterBoxSearchButton}>
              Search
            </ButtonT4>
          </RightSideWrapper>
        </FlexWrapperT11>
        <Spacer spacing={"3px"} />
        <FlexWrapperT7>
          <LineT1 />
          {/* <ButtonT9
            style={{ marginTop: "4px" }}
            onClick={handleToggleForMoreFilterBtn}
          >
            {isMoreFilterOpen ? "Less" : "More"}
            <ArrowOutline
              fill={"#FFF"}
              width={"20px"}
              transform={isMoreFilterOpen ? "rotate(90)" : "rotate(-90)"}
            />
          </ButtonT9> */}
        </FlexWrapperT7>
        {true && (
          <MoreWrapper>
            <FlexWrapperT12>
              <Wrapper style={{ minWidth: "100px" }}>
                <LabelT5>Road</LabelT5>
              </Wrapper>
              <Wrapper>
                <LabelT4>Avg Freight</LabelT4>
                <Spacer spacing={"1px"} />
                <SelectT1
                  isClearable={true}
                  options={freightDays}
                  value={avgFreight}
                  onChange={handleOnChangeAvgFreight}
                  styles = {
                    {control: (styles, state) => {
                      return {
                        ...styles,
                        width: getWidth(avgFreight,10),
                      };
                    },}
                   }
                />
              </Wrapper>
              <Wrapper>
                <LabelT4>Vehicle Type</LabelT4>
                <Spacer spacing={"1px"} />
                <SelectT1
                  isClearable={true}
                  options={vehicleDetails}
                  value={vehicleType}
                  onChange={handleOnChangeVehicleType}
                  isMulti
                />
              </Wrapper>
            </FlexWrapperT12>
            <Spacer spacing={"5px"} />
            <LineT1 />
            <Spacer spacing={"5px"} />
            <FlexWrapperT4>
              <Wrapper style={{ minWidth: "100px" }}>
                <LabelT5>Rail</LabelT5>
              </Wrapper>
              <FlexWrapperT12>
                <Wrapper>
                  <LabelT4>Rake Type</LabelT4>
                  <Spacer spacing={"1px"} />
                  <SelectT1
                    isClearable={true}
                    options={railRakeList}
                    value={railRake}
                    onChange={handleOnChangeRailRake}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT4>Wagon Weight</LabelT4>
                  <Spacer spacing={"1px"} />
                  <SelectT1
                    isClearable={true}
                    options={wagonTypes}
                    value={wagonType}
                    onChange={handleOnChangeWagonType}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT4>Origin Yard</LabelT4>
                  <Spacer spacing={"1px"} />
                  <SelectT1
                     styles = {
                      {control: (styles, state) => {
                        return {
                          ...styles,
                          width: getWidth(originYard),
                        };
                      },}
                     }
                    isClearable={true}
                    options={originYardList}
                    value={originYard}
                    onChange={handleOnChangeOriginYard}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT4>Destination Yard</LabelT4>
                  <Spacer spacing={"1px"} />
                  <SelectT1
                     styles = {
                      {control: (styles, state) => {
                        return {
                          ...styles,
                          width: getWidth(destinationYard,60),
                        };
                      },}
                     }
                    isClearable={true}
                    options={destinationYardList}
                    value={destinationYard}
                    onChange={handleOnChangeDestinationYard}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT4>Commodity Category</LabelT4>
                  <Spacer spacing={"2px"} />
                  <SelectT1
                     styles = {
                      {control: (styles, state) => {
                        return {
                          ...styles,
                          width: getWidth(commodityCategory,40),
                        };
                      },}
                     }
                    isClearable={true}
                    value = {commodityCategory}
                    options={commodityCategoryList}
                    onChange={(data) => {
                      handleOnChangeCommodityCategory(data);
                    }}
                  />
                </Wrapper>
              </FlexWrapperT12>
            </FlexWrapperT4>
          </MoreWrapper>
        )}
      </FilterBoxWrapper>
    </Fragment>
  );
};

export default FilterBox;

const FilterBoxWrapper = styled.div`
  background-color: #528aea;
  box-shadow: 0px 0px 8px rgba(82, 138, 234, 0.24);
  padding: 15px;
  border-radius: 6px;
`;

const LeftSideWrapper = styled(Wrapper)`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  flex: 1;
`;
const RightSideWrapper = styled(Wrapper)`
  display: flex;
`;

const LineT1 = styled.div`
  border-bottom: 1px solid #fff;
  width: 100%;
  height: 1px;
`;
const MoreWrapper = styled(Wrapper)``;
